import Icon from '../Icon/Icon';
import Navbar from '../Navbar/Navbar';

import useHeader from './useHeader';

import styles from './Header.module.scss';
import ContactDropdown from '../ContactDropdown/ContactDropdown';
import DropdownMenu from '../DropdownMenu/DropdownMenu';
import InviteUser from '../InviteUser/InviteUser';

const Header = () => {
	const {
		state: {
			isLoggedIn,
			showContactDropdown,
			showInviteDropdown,
			showMyProfileDropdown
		},
		imageId,
		isAuthorized,
		toggleContactDropdown,
		toggleInviteDropdown,
		toggleMyProfileDropdown,
	} = useHeader();

	return isLoggedIn ? (
		<div className={styles.wrapper}>
			<div className={styles.logo}>
				<img src="logo-black.png" alt="logo" />
			</div>

			<Navbar className={styles.navbar} />
			<div className={styles.user}>
				{isAuthorized(['ViewChatRequests']) && <div className={`${styles.dropdown} ${showContactDropdown ? styles.active : ''}`} onClick={toggleContactDropdown}>
					<Icon name="comments-alt" type="solid" color="gray" />
				</div>}
				{isAuthorized(['InviteUser']) && <div className={`${styles.dropdown} ${showInviteDropdown ? styles.active : ''}`} onClick={toggleInviteDropdown}>
					<Icon name="user-plus" type="solid" color="gray" />
				</div>}
				{showContactDropdown && <ContactDropdown onClose={toggleContactDropdown} />}
				{showInviteDropdown && <InviteUser onClose={toggleInviteDropdown}/>}
				{imageId ?
					<div onClick={toggleMyProfileDropdown}>
						<img alt="" src={imageId} className={styles.avatarImage} />
					</div> :
					<div className={styles.iconContainer}>
						<div className={styles.avatar} onClick={toggleMyProfileDropdown} >
							<Icon
								color="text"
								height="12px"
								name="user"
								width="12px"
							/>
						</div>
					</div>}
				<DropdownMenu onClose={toggleMyProfileDropdown} isOpen={showMyProfileDropdown} />
			</div>
		</div>
	) : <></>
}

export default Header;